// extracted by mini-css-extract-plugin
export var dropdown = "_tw-0";
export var imageWrapper = "_tw-3";
export var itemNameContainer = "_tw-1";
export var productImage = "_tw-2";
export var spinnerWrapper = "_tw-4";